export const BREAK_POINTS = {
  small: 768,
  medium: 1024,
  large: 1440,
}
